const ansiRegex = require('ansi-regex')

module.exports = {
    lintOnSave: true,
    publicPath: process.env.NODE_ENV === 'production' ? '/gri_2022/' : './',

    devServer: {
         overlay: {
	        warnings: false,
	        errors: true
        },
        disableHostCheck: true,
        public: 'localhost'                                                                                                                                    
    },
    transpileDependencies: [ansiRegex],
}
